import styled from '@emotion/styled'
import { Icon } from 'components/icon'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'

export const DIDLicense = (props?: { className?: string }) => {
  const { t } = useTranslation('memory')
  return (
    <SLicenseContainer className={props?.className}>
      <Text>{t('memory.live.licenced')}</Text>
      <Icon name="LogoDid" />
    </SLicenseContainer>
  )
}

export const SLicenseContainer = styled.div`
  display: flex;
  align-items: center;

  & > span {
    margin-right: 0.5rem;
  }
`
